import shaka from 'shaka-player';

import { PALLYCON_LA_URL, PALLYCON_CUSTOM_HEADER } from 'constants/shakaPlayer';
import { FAIR_PLAY_DRM, getBrowserSpecificInfos } from 'services/helpers/browser';
import { LicenseInfo } from 'shared-types/license-info';

export const generateLicenseInfo = (videoFilename: string, userId: string): LicenseInfo => {
  return {
    ...getBrowserSpecificInfos(),
    userId,
    videoFilename,
  };
};

export const onLicenseRequest = (licenseToken: string, request: any) => {
  if (getBrowserSpecificInfos().drmType === FAIR_PLAY_DRM) {
    const originalPayload = new Uint8Array(request.body);
    const base64Payload = shaka.util.Uint8ArrayUtils.toBase64(originalPayload);
    const params = `spc=${encodeURIComponent(base64Payload)}`;

    request.uri = `${PALLYCON_LA_URL}?${params}`;
    request.boy = base64Payload;
  }

  request.headers[PALLYCON_CUSTOM_HEADER] = licenseToken;
};

const arrayBufferToString = (buffer: Buffer): string => {
  const arr = new Uint8Array(buffer);
  const str = String.fromCharCode(...arr);
  return str;
};

const logPallyconError = (responseText: string) => {
  const { message, errorCode } = JSON.parse(responseText);

  // Error code 8002 is a custom error and need to be parsed differently
  if (errorCode === 8002) {
    const { MESSAGE, ERROR } = JSON.parse(message);
    console.error(`Error : ${MESSAGE} (${ERROR})`);
    return;
  }
  console.error(`PallyCon Error : ${message} (${errorCode})`);
};

export const onLicenseResponse = (responseData: Buffer) => {
  const responseText = arrayBufferToString(responseData);

  if (responseText.indexOf('errorCode') > 0) {
    logPallyconError(responseText);
  }
};

const base64DecodeUint8Array = (input: string): Uint8Array => {
  const raw = window.atob(input);
  const rawLength = raw.length;
  const array = new Uint8Array(new ArrayBuffer(rawLength));

  for (let i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i);
  }

  return array;
};

// We pass the whole player as paramter here because player.drmInfo() is undefined outside of initDataTransform
export const getPlayerConfiguration = (fairPlayCertificate: string, player: shaka.Player) => {
  // Default case for DRM that are not Apple Fair Play DRM
  if (getBrowserSpecificInfos().drmType !== FAIR_PLAY_DRM) {
    return {
      drm: {
        servers: {
          'com.widevine.alpha': PALLYCON_LA_URL,
          'com.microsoft.playready': PALLYCON_LA_URL,
        },
        advanced: {
          'com.widevine.alpha': {
            videoRobustness: 'SW_SECURE_CRYPTO',
            audioRobustness: 'SW_SECURE_CRYPTO',
          },
        },
      },
    };
  }

  // For Apple Fair play streaming DRM, we need a more advanced configuration
  const fairPlayCert = base64DecodeUint8Array(fairPlayCertificate);
  return {
    drm: {
      servers: {
        'com.apple.fps.1_0': PALLYCON_LA_URL,
      },
      advanced: {
        'com.apple.fps.1_0': {
          serverCertificate: fairPlayCert,
        },
      },
      initDataTransform: (initData: Buffer): Uint8Array => {
        const skdUri = shaka.util.StringUtils.fromBytesAutoDetect(initData);
        const contentId = skdUri.substring(skdUri.indexOf('skd://') + 6);
        return shaka.util.FairPlayUtils.initDataTransform(
          initData,
          contentId,
          player.drmInfo().serverCertificate,
        );
      },
    },
  };
};
